<template>

    <body>
        <header data-copilot="true" class="section overflow_hidden overflow_clip padding_small">
            <div class="min-height_100dvh">
                <div class="container z-index_2 position_relative text-align_center"><img
                        src="https://cdn.prod.website-files.com/686b0fce62ce6721b0225627/6875166c9fa43fc5647169d7_logo%20256%20dark%20bg.png"
                        loading="lazy" alt=""></div>
                <div class="container">
                    <div class="w-layout-grid grid_2-col height_100percent bordered margin-top_small">
                        <div id="w-node-f8ee0a7a-f949-e000-ca4c-1d6780cd2334-a68eb961"
                            data-w-id="f8ee0a7a-f949-e000-ca4c-1d6780cd2334"
                            style="opacity: 1; transform: translate3d(0px, 0px, 0px) scale3d(1, 1, 1) rotateX(0deg) rotateY(0deg) rotateZ(0deg) skew(0deg, 0deg); transform-style: preserve-3d;"
                            class="card_body padding_small">
                            <h3 id="w-node-_63aea21b-2f8e-997d-88e2-174767407b0f-67407b01"
                                class="heading_h4 w-node-f8ee0a7a-f949-e000-ca4c-1d6780cd2338-a68eb961">Welcome to Leap
                                Perks Program</h3>
                            <p class="paragraph_small margin-bottom_none">We’re excited to have you on board.<br><br>To
                                help us personalize your experience, could you please tell us a bit about your
                                business?<br><br>‍<strong>Just two quick things:<br>Your Business Name and
                                    Industry</strong>, So we
                                know who we’re working with.<br>‍<strong>Your Contact Info</strong>, So we can reach
                                you if needed.<br><br>It only takes a minute. <br><br>Let’s get started!</p>
                        </div>
                        <div class="form w-form">
                            <form class="flex_vertical gap-xsmall padding_small" aria-label="Email Form">
                                <h5 class="heading_h2">Business Info</h5>
                                <input class="input_field w-input" maxlength="256" placeholder="Business Name"
                                    type="text" required="" v-model="businessName">
                                <input class="input_field w-input" maxlength="256" placeholder="Business Industry"
                                    type="text" required="" v-model="businessIndustry">
                                <input class="input_field w-input" maxlength="256" placeholder="Contact Email"
                                    type="email" required="" v-model="contactEmail">
                                <input class="input_field w-input" maxlength="256" placeholder="Contact Phone"
                                    type="tel" required="" v-model="contactPhone">
                                <div class="button radius_medium" @click="updateBusinessInfo">Enroll</div>
                            </form>
                            <div class="w-form-done" tabindex="-1" role="region" aria-label="Email Form success">
                                <div>Thank you! Your submission has been received!</div>
                            </div>
                            <div class="w-form-fail" tabindex="-1" role="region" aria-label="Email Form failure">
                                <div>Oops! Something went wrong while submitting the form.</div>
                            </div>
                        </div>
                        <ul role="list" id="w-node-a3ee1c64-ae0f-9aac-c410-428e3cb6fc23-a68eb961"
                            data-w-id="a3ee1c64-ae0f-9aac-c410-428e3cb6fc23"
                            style="opacity: 1; transform: translate3d(0px, 0px, 0px) scale3d(1, 1, 1) rotateX(0deg) rotateY(0deg) rotateZ(0deg) skew(0deg, 0deg); transform-style: preserve-3d;"
                            class="grid_3-col gap-small position_relative padding_small w-list-unstyled">
                            <li class="margin-bottom_none">
                                <div class="is-large-1x1 margin-bottom_xsmall is-background"><svg
                                        xmlns="http://www.w3.org/2000/svg" width="100%" height="100%"
                                        viewBox="0 0 24 24" fill="none">
                                        <path d="M5.25 6.75H18.75V17.25H5.25V6.75Z" stroke="currentColor"
                                            stroke-width="1.5" stroke-linejoin="round"></path>
                                        <path d="M5.25 6.75L12 12L18.75 6.75" stroke="currentColor" stroke-width="1.5"
                                            stroke-linejoin="round"></path>
                                    </svg></div>
                                <h5 class="heading_h5">Send an email</h5>
                                <p class="text-color_secondary">Share your ideas or ask us anything.</p>
                                <div><a href="#" class="text-link is-secondary">hello@leapdigitalmedia.ca</a></div>
                            </li>
                            <li class="margin-bottom_none">
                                <div class="is-large-1x1 margin-bottom_xsmall is-background"><svg
                                        xmlns="http://www.w3.org/2000/svg" width="100%" height="100%"
                                        viewBox="0 0 24 24" fill="none">
                                        <path
                                            d="M12.5 18.25C16.2279 18.25 19.25 15.2279 19.25 11.5C19.25 7.77208 16.2279 4.75 12.5 4.75C8.77208 4.75 5.75 7.77208 5.75 11.5C5.75 12.6007 6.01345 13.6398 6.48072 14.5578L5 19L9.71819 17.6519C10.5664 18.0361 11.5082 18.25 12.5 18.25Z"
                                            stroke="currentColor" stroke-width="1.5" stroke-linejoin="round"></path>
                                    </svg></div>
                                <h4 class="heading_h5">Give us a call</h4>
                                <p class="text-color_secondary">We’re here Mon–Fri, 8am–5pm PT.</p>
                                <div>+1 (705) 220-2273<br></div>
                            </li>
                            <li class="margin-bottom_none">
                                <div class="is-large-1x1 margin-bottom_xsmall is-background"><svg
                                        xmlns="http://www.w3.org/2000/svg" width="100%" height="100%"
                                        viewBox="0 0 24 24" fill="none">
                                        <path
                                            d="M16.3918 14.8527C20.2489 10.9956 17.2769 4.25 12 4.25C6.72299 4.25 3.75102 10.9956 7.60817 14.8527L12 19.25L16.3918 14.8527Z"
                                            stroke="currentColor" stroke-width="1.5" stroke-linejoin="round"></path>
                                        <circle cx="12" cy="10.25" r="2" stroke="currentColor" stroke-width="1.5">
                                        </circle>
                                    </svg></div>
                                <h4 class="heading_h5">Stop by our office</h4>
                                <p class="text-color_secondary">Visit us and meet our creative team.</p>
                                <div>435 Notre Dame Ave,<br>Sudbury, ON, P3C 5K6<br>Canada</div>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </header>
        <Loading v-if="isLoading" />
    </body>
</template>

<script>

import { auth, db } from '@/firebase';
import { onAuthStateChanged } from 'firebase/auth';
import { doc, updateDoc  } from 'firebase/firestore';
import Loading from '@/components/loading.vue';

export default {
    name: 'onboardingView',
    components: {
        Loading,
    },
    data() {
        return {
            businessIndustry: '',
            businessName: '',
            contactPhone: '',
            contactEmail: '',
            isLoading: false,
        };
    },
    async mounted() {
        const user = auth.currentUser;
        // Check if user is already logged in
        onAuthStateChanged(auth, async (user) => {
            if (user) {
                
                
            } else {
                this.$router.push('/'); // Redirect to home if user is not signed in
                console.log("No user is signed in.");
            }
        });

    },
    methods: {
        async updateBusinessInfo() {
            this.isLoading = true;
            try {
                const user = auth.currentUser;
                if (user) {
                    const userRef = doc(db, 'users', user.uid);
                    await updateDoc(userRef, {
                        businessIndustry: this.businessIndustry,
                        businessName: this.businessName,
                        phoneNumber: this.contactPhone,
                        contactEmail: this.contactEmail,
                        enrolled: true,
                    });
                    console.log("Business information updated successfully.");
                    this.$router.push('/portal'); // Redirect to portal after updating info
                }
            } catch (error) {
                console.error("Error updating business information:", error);
            } finally {
                this.isLoading = false;
            }
        }
    }
};
</script>